import { createButton, createElement } from "./dom";

const CONTROL_ROWS: ReadonlyArray<readonly [string, string]> = [
  ["W / A / S / D", "ДВИЖЕНИЕ"],
  ["МЫШЬ", "ОБЗОР"],
  ["ЛКМ", "ОГОНЬ"],
  ["E", "ДВЕРЬ / ПАНЕЛЬ / ЭВАКУАЦИЯ"],
  ["ЛЕВЫЙ ИЛИ ПРАВЫЙ SHIFT", "БЕГ"],
  ["R", "ПЕРЕЗАРЯДКА"],
  ["1 / 2 / 3 ИЛИ КОЛЕСО МЫШИ", "ВЫБОР ОРУЖИЯ"],
  ["TAB", "КАРТА"],
  ["ESC", "ПАУЗА / ОСВОБОДИТЬ МЫШЬ"],
];

const MOBILE_CONTROL_ROWS: ReadonlyArray<readonly [string, string]> = [
  ["ЛЕВЫЙ СТИК", "ДВИЖЕНИЕ"],
  ["ПРАВАЯ ОБЛАСТЬ ЭКРАНА", "ОБЗОР ПО ГОРИЗОНТАЛИ"],
  ["ОГОНЬ + ДВИЖЕНИЕ ПАЛЬЦА", "СТРЕЛЬБА И ОБЗОР ПО ГОРИЗОНТАЛИ"],
  ["ДЕЙСТВИЕ", "ДВЕРЬ / ЭВАКУАЦИЯ РЯДОМ"],
  ["ЗАРЯДИТЬ", "ПЕРЕЗАРЯДКА"],
  ["БЕГ", "ВКЛЮЧИТЬ / ВЫКЛЮЧИТЬ БЕГ"],
  ["ОРУЖИЕ", "ПЕРЕКЛЮЧЕНИЕ ОРУЖИЯ"],
  ["КАРТА", "ОТКРЫТЬ / ЗАКРЫТЬ АВТОКАРТУ"],
  ["ПАУЗА", "МЕНЮ ПАУЗЫ"],
];

export class ControlsMenu {
  public readonly element = createElement("section", "screen overlay-screen hidden");
  private readonly grid = createElement("dl", "controls-grid");

  public constructor(onClose: () => void) {
    this.element.append(
      createElement("div", "eyebrow", "ПАМЯТКА ПОЛЕВОГО ОПЕРАТОРА"),
      createElement("h2", undefined, "УПРАВЛЕНИЕ"),
    );
    const actions = createElement("div", "settings-actions");
    actions.append(createButton("НАЗАД", onClose));
    this.element.append(this.grid, actions);
  }

  public show(touch = false): void {
    this.grid.replaceChildren();
    for (const [input, action] of touch ? MOBILE_CONTROL_ROWS : CONTROL_ROWS) {
      const row = createElement("div", "control-row");
      row.append(createElement("dt", undefined, input), createElement("dd", undefined, action));
      this.grid.append(row);
    }
    this.element.classList.remove("hidden");
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }
}
